import { NotifyHelper } from "../../../helpers/toast";
import { eThanhPhanThiActionsObj } from "../../action-types/category/IThanhPhanThiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const thanhPhanThiActions = {
    ...generateActions(eThanhPhanThiActionsObj, "THANH_PHAN_THI"),
    ...generateActionForKey(eThanhPhanThiActionsObj, "THANH_PHAN_THI","SAVE_SUCCESS", () => {
        NotifyHelper.Success("Thành công");
    }),
    ...generateActionForKey(eThanhPhanThiActionsObj, "THANH_PHAN_THI","DELETE_SUCCESS", () => {
        NotifyHelper.Success("Thành công");
    }),
    ...generateActionForKey(eThanhPhanThiActionsObj, "THANH_PHAN_THI","SAVE_ERROR", (m) => {
        NotifyHelper.Error(m);
    }),
    ...generateActionForKey(eThanhPhanThiActionsObj, "THANH_PHAN_THI","DELETE_ERROR", (m) => {
        NotifyHelper.Error(m);
    }),
};